module.exports = __webpack_public_path__ + "static/media/point+15.49ba28f2.png";